<div id="modalrooms" style="position: relative">
  <div id="modalRooms">
    <div class="modal-content" style="padding-bottom: 50px; padding-top: 3em; padding-bottom: 3em">
      <div class="d-flex justify-content-between align-items-start" style="margin-left: 2.8em; margin-right: 2em">
        <div class="d-flex flex-column">
          <p
            class="title mb-0"
            style="
              font-family: &quot;Rubik&quot;, sans-ferif;
              font-size: 14px;
              font-weight: 500;
              line-height: 1 !important;
              color: #3f3f3f !important;
              text-transform: uppercase;
            "
          >
            {{ payload[0]?.city }}
          </p>
          <p
            class="title mb-0"
            style="
              font-family: &quot;Poppins&quot;, sans-ferif;
              font-size: 29px;
              font-weight: 500;
              line-height: 1 !important;
              color: #3f3f3f !important;
              margin-top: 4px;
            "
          >
            {{ tour.title }}
          </p>
          <ng-container *ngIf="tour?.comments">
            <p class="average mb-0 d-flex align-items-center" style="margin-top: 9px">
              <span class="d-flex align-items-center" *ngIf="tour?.comments?.averageStars > 0">
                <span
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: black;
                    border-radius: 50%;
                    width: 26px;
                    height: 26px;
                  "
                  [ngStyle]="{ color: clientSetting?.clients_setting_global?.color_main_1 }"
                  >{{ tour?.comments?.averageStars * 2 }}</span
                >
                <span *ngIf="tour?.comments?.averageStars > 0" style="margin-left: 3px">{{
                  getCommentadjective(tour?.comments?.averageStars)
                }}</span>
              </span>
              <span *ngIf="tour?.comments?.averageStars === 0" style="height: 26px"></span>
              <span
                class="rubik-regular-12pt"
                [ngStyle]="{
                  color: tour?.comments?.averageStars > 0 ? 'black' : '#bbbbbb',
                  'margin-left': tour?.comments?.averageStars > 0 ? '3px' : ''
                }"
              >
                {{ tour?.comments?.averageStars > 0 ? "puntuación" : "Sin puntuación" }}</span
              >
            </p>
          </ng-container>
        </div>

        <button type="button" class="close btn-closed" aria-label="Close" (click)="close()">
          <span aria-hidden="true" style="font-size: 50px; font-weight: 100">&times;</span>
        </button>
      </div>

      <div
        *ngIf="action && action !== 'comments'"
        class="d-flex py-2 justify-content-between"
        style="
          margin-top: 47px;
          margin-bottom: 18px;
          background-color: #fcfcfc;
          border: 1px solid #ececec;
          border-radius: 6px;
          margin-left: 2.8em;
          margin-right: 2em;
        "
      >
        <button
          *ngIf="quote"
          [ngStyle]="{
            color: tab === 'tour' ? buttonColorActive : buttonTextActive
          }"
          class="btn-tabs"
          (click)="tab = 'tour'"
          style="border-right: 1px solid #ececec"
        >
          {{ categorieSubCategoryName() }}
        </button>
        <button
          [ngStyle]="{
            color: tab === 'info' ? buttonColorActive : buttonTextActive
          }"
          class="btn-tabs"
          (click)="tab = 'info'"
          style="border-right: 1px solid #ececec"
        >
          INFO
        </button>
        <button
          [ngStyle]="{
            color: tab === 'photos' ? buttonColorActive : buttonTextActive
          }"
          class="btn-tabs"
          (click)="tab = 'photos'"
          style="border-right: 1px solid #ececec"
        >
          FOTOS
        </button>
        <button
          [ngStyle]="{
            color: tab === 'maps' ? buttonColorActive : buttonTextActive
          }"
          class="btn-tabs"
          (click)="tab = 'maps'; mapMarker()"
          style="border-right: 1px solid #ececec"
        >
          MAPA
        </button>
        <button
          [ngStyle]="{
            ' color': tab === 'comments' ? buttonColorActive : buttonTextActive
          }"
          class="btn-tabs"
          (click)="tab = 'comments'"
        >
          COMENTARIOS
        </button>
      </div>

      <ng-container *ngIf="quote">
        <!-------------------------- DIV DE TOUR --------------------------------->
        <div [ngClass]="{ 'd-block': tab === 'tour', 'd-none': tab != 'tour' }">
          <div class="d-flex flex-column mb-2" style="margin-left: 2.8em; margin-right: 2em">
            <div
              class="d-flex flex-row justify-content-around"
              style="height: 323.5px; gap: 0.25em"
              *ngIf="payload[0].categoriesId[0] == 6 && !validateImages"
            >
              <ng-container *ngFor="let image of tour.additionalInfo?.images; let i = index">
                <ng-container *ngIf="i === 0">
                  <div class="d-flex" style="height: auto; width: 100%">
                    <picture class="w-100">
                      <img [src]="image.thumbnail" style="width: 100%; height: 323.5px; object-fit: cover" alt="image_tour" />
                    </picture>
                  </div>
                </ng-container>
              </ng-container>
              <div class="d-flex flex-column" style="height: auto; width: 50%">
                <ng-container *ngFor="let image of tour.additionalInfo?.images; let i = index">
                  <ng-container *ngIf="i > 0 && i <= 2">
                    <div *ngIf="i === 1" class="w-100 h-50">
                      <picture>
                        <img [src]="image.thumbnail" style="width: 100%; height: 159.5px; object-fit: cover" alt="image_tour" />
                      </picture>
                    </div>
                    <div *ngIf="i === 2" class="w-100 h-50 mt-1" style="position: relative">
                      <picture>
                        <img [src]="image.thumbnail" style="width: 100%; height: 159.5px; object-fit: cover" alt="image_tour" />
                      </picture>
                      <button
                        (click)="tab = 'photos'"
                        type="button"
                        class="px-4 py-2 rounded-pill d-flex align-items-center justify-content-center"
                        style="border: none; background-color: #ececec; position: absolute; bottom: 1em; right: 2em"
                      >
                        <p class="mb-0" style="font-family: &quot;Rubik&quot;, sans-serif; font-size: 9px; font-weight: 600">
                          + de {{ tour.additionalInfo.images.length - 1 }} fotos
                        </p>
                      </button>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </div>

            <!-- Images Tickets -->
            <div
              class="d-flex flex-row justify-content-around"
              style="height: 323.5px; gap: 0.25em"
              *ngIf="payload[0].categoriesId[0] == 9 && !validateImages"
            >
              <div class="d-flex" style="height: auto; width: 100%">
                <ng-container *ngFor="let image of tour.additionalInfo?.images; let i = index">
                  <ng-container *ngIf="i === 0">
                    <picture class="w-50">
                      <img [src]="image.thumbnail" style="width: 100%; height: 323.5px; object-fit: fill" alt="image_tour" />
                    </picture>
                  </ng-container>
                  <ng-container *ngIf="i === 1">
                    <picture class="w-50">
                      <img [src]="image.thumbnail" style="width: 100%; height: 323.5px; object-fit: fill" alt="image_tour" />
                    </picture>
                  </ng-container>
                </ng-container>
              </div>
              <div class="d-flex flex-column" style="height: auto; width: 50%">
                <ng-container *ngFor="let image of tour.additionalInfo?.images; let i = index">
                  <ng-container *ngIf="i > 1 && i <= 6">
                    <div *ngIf="i === 2" class="w-100 h-50">
                      <picture>
                        <img [src]="image.thumbnail" style="width: 100%; height: 159.5px; object-fit: fill" alt="image_tour" />
                      </picture>
                    </div>
                    <div *ngIf="i === 6" class="w-100 h-50 mt-1" style="position: relative">
                      <picture>
                        <img [src]="image.thumbnail" style="width: 100%; height: 159.5px; object-fit: fill" alt="image_tour" />
                      </picture>
                      <button
                        (click)="tab = 'photos'"
                        type="button"
                        class="px-4 py-2 rounded-pill d-flex align-items-center justify-content-center"
                        style="border: none; background-color: #ececec; position: absolute; bottom: 1em; right: 2em"
                      >
                        <p class="mb-0" style="font-family: &quot;Rubik&quot;, sans-serif; font-size: 9px; font-weight: 600">
                          + de {{ tour.additionalInfo.images.length - 1 }} fotos
                        </p>
                      </button>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </div>

            <p
              *ngIf="payload[0].categoriesId[0] == 6"
              class="description-tour mb-0"
              style="
                font-family: &quot;Rubik&quot;, sans-serif;
                font-size: 15px;
                font-weight: 400;
                line-height: 1.5;
                margin-top: 30px;
                padding-left: 1.5em;
                padding-right: 2.5em;
                color: #272729;
              "
            >
              {{ (tour.description ? tour.description : "") | truncate: 300 : "  " }}
              <a (click)="moreDescription()" style="cursor: pointer; font-weight: 500" class="more">...más</a>
            </p>
            <p
              *ngIf="payload[0].categoriesId[0] == 9"
              class="description-tour mt-3 mb-0"
              style="
                font-family: &quot;Rubik&quot;, sans-serif;
                font-size: 15px;
                font-weight: 400;
                line-height: 1.3;
                margin-top: 30px;
                padding-left: 3em;
                padding-right: 2.5em;
                color: #272729;
              "
            >
              {{ (tour.description ? tour.description : "") | truncate: 300 : "  " }}
              <a (click)="moreDescription()" style="cursor: pointer; font-weight: 500" class="more">...más</a>
            </p>

            <div style="margin-top: 50px">
              <p style="
                font-family: &quot;Poppins&quot;, serif;
                font-size: 19px;
                font-weight: 600;
                padding-left: 1.2em
              ">
                Información general
              </p>

              <div class="d-flex flex-column justify-content-center" style="width: 100%; margin-bottom: 1.25em">
                <div class="d-flex align-items-center" style="padding-left: 1.2em">
                  <img src="../../../../../assets/icons/itinerary/calendar_13937514.svg" width="26px" height="26px" alt="" />
                  <p class="mb-0" style="font-family: &quot;Poppins&quot;, serif; font-size: 14px; font-weight: 600; margin-left: 0.15em">
                    Cancelación {{ tour?.additionalInfo?.tours?.options[0]?.rateClass === "R" ? "gratuita" : "" }}
                  </p>
                </div>
                <p
                  class="mb-0"
                  style="font-family: &quot;Rubik&quot;, sans-serif; font-size: 13px; font-weight: 400; line-height: 1; margin-left: 3.75em"
                >
                  <span *ngIf="tour?.additionalInfo?.tours?.options[0]?.rateClass === 'R'">
                    Cancela gratis hasta {{ cancellationPolicyDate | date: "dd/MM/yyyy" }} y recibe un reembolso completo
                  </span>
                  <span *ngIf="tour?.additionalInfo?.tours?.options[0]?.rateClass === 'NR'"> Cancelación con 100% de cargo </span>
                </p>
              </div>

              <div class="d-flex" style="border-top: 1px solid #b4b4b4; border-bottom: 1px solid #b4b4b4; height: 85px">
                <div
                  class="d-flex flex-column justify-content-center"
                  style="width: 100%"
                  [ngStyle]="{ 'border-right': payload[0].categoriesId[0] == 6 ? '1px solid #b4b4b4' : '0px' }"
                >
                  <div class="d-flex align-items-center" style="padding-left: 1.2em">
                    <img src="../../../../../assets/icons/search-result/tiempo_uso.svg" width="24px" alt="" />
                    <p class="mb-0" style="font-family: &quot;Poppins&quot;, serif; font-size: 14px; font-weight: 600; margin-left: 0.25em">
                      Duración {{ getDurations(tour?.additionalInfo?.tours?.options) }}
                    </p>
                  </div>
                  <p
                    *ngIf="periodsActivities(tour?.additionalInfo?.tours?.options) !== ''"
                    class="mb-0"
                    style="
                      font-family: &quot;Rubik&quot;, sans-serif;
                      font-size: 13px;
                      font-weight: 400;
                      line-height: 1;
                      margin-left: 3.6em;
                    "
                  >
                    Suele estar disponible por la {{ periodsActivities(tour?.additionalInfo?.tours?.options) }}
                  </p>
                  <p
                    *ngIf="periodsActivities(tour?.additionalInfo?.tours?.options) === ''"
                    class="mb-0"
                    style="
                      font-family: &quot;Rubik&quot;, sans-serif;
                      font-size: 13px;
                      font-weight: 400;
                      line-height: 1;
                      margin-left: 3.6em;
                    "
                  >
                    <span
                      *ngIf="
                        tour?.scheduling &&
                        tour?.scheduling &&
                        tour?.scheduling.length > 0 &&
                        tour?.scheduling[0]?.opened &&
                        tour?.scheduling[0]?.opened.length > 0
                      "
                    >
                      Abierto desde {{ tour?.scheduling[0].opened[0].openingTime }} hs. hasta
                      {{ tour?.scheduling[0].opened[0].closeTime }} hs.
                    </span>
                    <span *ngIf="tour?.scheduling.length === 0"> Suele estar abierto todo el día </span>
                  </p>
                </div>
                <div *ngIf="payload[0].categoriesId[0] == 6" class="d-flex flex-column justify-content-center ml-3" style="width: 100%">
                  <div class="d-flex align-items-center">
                    <img src="../../../../../assets/icons/search-result/tour/idioma.svg" width="23px" alt="" />
                    <p class="mb-0" style="font-family: &quot;Poppins&quot;, serif; font-size: 14px; font-weight: 600; margin-left: 0.5em">
                      Idioma
                    </p>
                  </div>

                  <p
                    class="mb-0"
                    style="
                      font-family: &quot;Rubik&quot;, sans-serif;
                      font-size: 13px;
                      font-weight: 400;
                      line-height: 1;
                      margin-left: 2.4em;
                    "
                  >
                    La actividad se realiza {{ getGuideAmenity(tour?.additionalInfo?.tours?.amenities.included) }}
                    <span style="text-transform: lowercase">{{ getLanguages(tour?.additionalInfo?.tours?.options) }}</span>
                  </p>
                </div>
              </div>

              <div class="d-flex flex-column justify-content-center" style="height: 85px;">
                <div class="d-flex align-items-center" style="padding-left: 1.2em">
                  <img src="../../../../../assets/icons/search-result/tour/gps.svg" width="21px" alt="" />
                  <p class="mb-0" style="font-family: &quot;Poppins&quot;, serif; font-size: 14px; font-weight: 600; margin-left: 0.5em">
                    Ubicación
                  </p>
                </div>
                <p
                  class="mb-0"
                  style="font-family: &quot;Rubik&quot;, sans-serif; font-size: 13px; font-weight: 400; line-height: 1; margin-left: 3.7em"
                >
                  {{ tour.additionalInfo.location ? tour.additionalInfo.location + ", " + payload[0]?.city : payload[0]?.city }}
                </p>
              </div>
            </div>
          </div>

          <div
            *ngIf="payload[0].categoriesId[0] == 6 || payload[0].categoriesId[0] == 9"
            style="margin-left: 2.8em; margin-right: 2em; margin-top: 90px"
          >
            <p style="
              font-family: &quot;Poppins&quot;, sans-serif;
              font-size: 19px;
              font-weight: 600;
              padding-left: 1.2em
            ">
              Seleccionar Fechas
            </p>

            <div
              class="d-flex flex-row align-items-center"
              [ngStyle]="{
                color: buttonTextActive,
                background: buttonColorActive
              }"
              style="
                border-top-left-radius: 6px;
                border-top-right-radius: 6px;
                margin-left: 0.75em;
                margin-right: 0.75em;
                padding-left: 0.5em;
              "
            >
              <button class="btn-prev d-flex align-items-center justify-content-center" style="border: none; background-color: transparent" (click)="prevMonth()">
                <i class="bi bi-caret-left-fill" style="font-size: 11px"></i>
              </button>
              <p
                class="mb-0"
                style="
                  font-family: 'Muli', sans-serif;
                  font-size: 12px;
                  font-weight: bold;
                  text-transform: uppercase;
                  color: black;
                  width: 110px;
                  margin: 0px 15px;
                  text-align: center;
                "
              >
                {{ getNameMonth() }}
              </p>
              <button
                class="btn-next d-flex align-items-center justify-content-center"
                style="border: none; background-color: transparent"
                (click)="nextMonth()"
              >
                <i class="bi bi-caret-right-fill" style="font-size: 11px"></i>
              </button>
            </div>

            <div class="calendar-container">
              <ol class="container-calendar">
                <!-- Días de la semana -->
                <li *ngFor="let dayWeek of week()" class="week-day">
                  <p class="week-day-text">{{ dayWeek }}</p>
                </li>

                <!-- Días del mes -->
                <li
                  *ngFor="let day of calendarDays; let i = index"
                  (click)="getDateClick(day.date, day)"
                  style="cursor: pointer"
                  [class.date-available]="day.isAvailable && day.isCurrentMonth && !getItineraryDayInItinerary(day)"
                  [class.date-unavailable]="!day.isAvailable && day.isCurrentMonth && !getItineraryDayInItinerary(day)"
                  [class.other-month]="!day.isCurrentMonth"
                  [class.selected]="day.date === dateSelect"
                  [class.has-experience]="getItineraryDayInItinerary(day) && day.isCurrentMonth"
                  [class.calendar-day]="day.isAvailable || !day.isCurrentMonth || getItineraryDayInItinerary(day)"
                  [class.calendar-day-unavailable]="!day.isAvailable"
                  [class.has-left-stripe]="shouldHaveLeftStripe(day, i) && !getItineraryDayInItinerary(day)"
                  [class.has-right-stripe]="shouldHaveRightStripe(day, i) && !getItineraryDayInItinerary(day)"
                  [style.background]="getBackgroundColor(day)"
                  [title]="getTourItineraryCalendar(day)?.description || ''"
                >

               
                  <!-- Número del día -->
                  <div class="day-number">
                    {{ day.number }}
                  </div>

                  <!-- Precios (solo para días disponibles) -->
                  <div class="day-prices" *ngIf="day.isAvailable && day.isCurrentMonth && !getItineraryDayInItinerary(day)">
                    <p class="price-label">Desde</p>
                    <p class="price-original">{{ tour.additionalInfo.currency }} {{ day.totalPriceProf | number: "1.2-2" }}.-</p>
                    <p
                      class="price-amount"
                      [ngStyle]="{
                        'font-size':
                          (day.totalPriceProf
                          | currencyConverterPure: tour.additionalInfo.currency : currencyAgency?.code : currencies
                          | dynamicFontSize: 11 : fontSizeAdjustments)
                      }"
                    >
                      {{ currencyAgency?.code }}
                      {{
                        day.totalPriceProf
                          | currencyConverterPure: tour.additionalInfo.currency : currencyAgency.code : currencies
                          | number: "1.2-2"
                      }}.-
                    </p>
                  </div>

                  <!-- Indicador de no disponible -->
                  <div
                    class="unavailable-text"
                    *ngIf="isPartOfUnavailableBlock(day)"
                    [class.first]="getDayPosition(day, calendarDays, i).isFirst"
                    [class.last]="getDayPosition(day, calendarDays, i).isLast"
                  >
                    <p class="unavailable-range">{{ getRangeDateUnavailable(day, calendarDays, i) }}</p>
                  </div>

                  <!-- Badge de experiencia en itinerario -->
                  <div
                    class="day-prices"
                    *ngIf="getItineraryDayInItinerary(day) && day.isCurrentMonth"
                  >
                    <ng-container *ngIf="day.isAvailable">
                      <p
                        class="mb-0"
                        style="
                          font-family: 'Muli', sans-serif;
                          font-size: 11px;
                          font-weight: 600;
                          line-height: 1.2;
                          color: #000000;
                          padding: 8px 4px 0px;
                          text-align: center;
                        "
                        tooltip="{{ getTourItineraryCalendar(day)?.title }}"
                        placement="bottom"
                      >
                        {{ getTourItineraryCalendar(day)?.title | truncate: 20 : "..." }}
                      </p>

                      <div
                        class="d-flex flex-column align-items-center justify-content-center px-2"
                        style="border-radius: 50rem; position: absolute; top: 8px; right: 8px"
                        [ngClass]="{
                          'product-status-saved': getTourItineraryCalendar(day)?.status_id === 1,
                          'product-status-reserved': getTourItineraryCalendar(day)?.status_id === 2,
                          'product-status-cancelled': getTourItineraryCalendar(day)?.status_id === 5
                        }"
                      >
                        <span
                          style="
                            font-family: &quot;Muli&quot;, sans-serif;
                            font-size: 9px;
                            font-weight: 500;
                            margin-bottom: 0;
                            line-height: 1;
                            padding: 4px;
                          "
                          [ngStyle]="{ 'color': getTourItineraryCalendar(day)?.status_id === 2 ? '#000000' : '#FFFFFF' }"
                        >
                          {{
                            getTourItineraryCalendar(day)?.status_id === 1
                              ? "Cotizado"
                              : getTourItineraryCalendar(day)?.status_id === 2
                                ? "Reservado"
                                : "Cancelado"
                          }}</span
                        >
                      </div>

                      <!-- <span style="font-family: 'Muli', sans-serif;font-size: 9px; font-weight: 500; margin-bottom: 0; line-height: 1;">1x experiencia {{getTourItineraryCalendar(day)?.status_id === 1 ? 'cotizada' : getTourItineraryCalendar(day)?.status_id === 2 ? 'reservada' : 'cancelada'}}</span> -->
                    </ng-container>

                    <ng-container *ngIf="!day.isAvailable">
                      <div
                        class="d-flex flex-column align-items-center justify-content-center px-2"
                        style="border-radius: 50rem; position: absolute; top: 8px; right: 8px"
                        [ngClass]="{
                          'product-status-saved': getTourItineraryCalendar(day)?.status_id === 1,
                          'product-status-reserved': getTourItineraryCalendar(day)?.status_id === 2,
                          'product-status-cancelled': getTourItineraryCalendar(day)?.status_id === 5
                        }"
                      >
                        <span
                          style="
                            font-family: &quot;Muli&quot;, sans-serif;
                            font-size: 9px;
                            font-weight: 500;
                            margin-bottom: 0;
                            line-height: 1;
                            color: white;
                            padding: 4px;
                          "
                        >
                          {{
                            getTourItineraryCalendar(day)?.status_id === 1
                              ? "Cotizado"
                              : getTourItineraryCalendar(day)?.status_id === 2
                                ? "Reservado"
                                : "Cancelado"
                          }}</span
                        >
                      </div>

                      <p
                        style="
                          font-family: &quot;Muli&quot;, sans-serif;
                          font-size: 11px;
                          font-weight: 500;
                          margin-bottom: 0;
                          line-height: 1;
                          padding: 12px 17% 0px 17%;
                        "
                        tooltip="{{ getTourItineraryCalendar(day)?.title }}"
                        placement="bottom"
                      >
                        {{ getTourItineraryCalendar(day)?.title | truncate: 29 : "..." }}
                      </p>
                    </ng-container>
                  </div>
                </li>
              </ol>
            </div>
          </div>

          <!--------------- Pasajeros --------------->

          <div
            class="d-flex"
            [ngStyle]="{ gap: payload[0].categoriesId[0] === 9 ? '1em' : '' }"
            style="
              border-radius: 15px;
              box-shadow: 2px 4px 10px 0px rgba(0, 0, 0, 0.1);
              margin-left: 3.6em;
              margin-right: 2.9em;
              margin-top: 60px;
              margin-bottom: 60px;
              border: 0.5px solid #ececec;
            "
          >
            <div style="width: 100%; padding: 40px;">
              <div class="d-flex align-items-center pb-3" style="gap: 0.5em;">
                <img src="../../../../assets/icons/itinerary/persona.svg" width="24px" alt="" />
                <p class="mb-0" style="font-family: &quot;Poppins&quot;, sans-serif; font-size: 19px; font-weight: 600; line-height: 1.2;">
                  Cantidad pasajeros
                  <span
                    *ngIf="verifyChildren()"
                    style="
                      font-size: 14px !important;
                      font-weight: 600;
                      font-family: 'Poppins';
                      color: #ed3b5b;
                    "
                  >
                    (Actividad no apta para menores de edad)
                  </span>
                </p>
              </div>

              <div class="d-flex mt-2">
                <div style="width: 100%">
                  <div class="d-flex align-items-center" style="position: relative" #passengerContainer>
                    <button
                      type="button"
                      class="d-flex justify-content-between align-items-center form-control btn-usb-rp element-config-passenger"
                      (click)="_openModal()"
                      [attr.aria-expanded]="!isCollapsed"
                      aria-controls="false"
                      style="
                        font-family: &quot;Poppins&quot;, sans-serif !important;
                        font-size: 15px !important;
                        font-weight: 600 !important;
                        color: #464646;
                        height: 50px;
                        padding: 0px 35px;
                        border-radius: 10px !important;
                        border-color: #f0f0f0;
                        border-width: 2px;
                      "
                    >
                      {{ passengers }}
                      <img
                        width="13"
                        height="13"
                        class="arrow-sort"
                        src="../../../../../assets/img/app/little-icons/caret.svg"
                      />
                    </button>
                    <div
                      #collapseElement
                      (collapsed)="clickOutside($event)"
                      (expanded)="($event)"
                      [collapse]="!isCollapsed || _close"
                      class="justify-content-end config-passenger"
                    >
                      <div class="card p-4">
                        <ng-container *ngFor="let priceCount of optionsTour[0].paxPrices; let i = index; let last = last">
                          <div
                            style="width: 100%; padding-top: 1em; padding-bottom: 1em; padding-left: 15px;"
                            [ngStyle]="{ 'border-bottom': !last ? '1px solid #cececd' : 'none' }"
                          >
                            <div class="d-flex align-items-start mb-2">
                              <div class="d-flex flex-column" style="width: 30%">
                                <p class="vehicle-middle-description" style="font-weight: 600; line-height: 1.2; margin-bottom: 2px;
                                font-size: 14px !important;">
                                  {{ getPaxType(priceCount.paxType) }} x {{ getPassengerCount(i) }}  <span style="font-size: 14px; font-family: 'Rubik';">({{optionsTour[0]?.currency}} {{ priceCount.amount }} c/u)</span>
                                </p>
                                <p class="mb-0 vehicle-middle-description" style="font-size: 12px; font-weight: 400; line-height: 1.2">
                                  + de {{ priceCount.ageFrom }} años
                                </p>
                              </div>

                              <div class="d-flex align-items-start" style="width: 75%;">
                                <div class="input-group" style="width: 30%; gap: 5px;">
                                  <button
                                    type="button"
                                    style="border: none; background-color: transparent; font-family: 'Rubik';"
                                    (click)="decrementPassenger(i, priceCount)"
                                    [disabled]="getPassengerCount(i) <= 0 || (i === indexPaxMandatory && getPassengerCount(i) <= 1)"
                                  >
                                    <p class="mb-0" style="font-size: 20px; font-weight: 700; font-family: 'Rubik';">-</p>
                                  </button>

                                  <input
                                    type="text"
                                    class="form-control text-center"
                                    style="border-radius: 8px; max-width: 50px; border-width: 1.5px; font-weight: 500; font-family: 'Poppins';"
                                    [value]="getPassengerCount(i)"
                                    [min]="0"
                                    [max]="getMaxPassengers(i)"
                                    (change)="validatePassengerInput($event, i)"
                                  />

                                  <button
                                    type="button"
                                    style="border: none; background-color: transparent"
                                    (click)="incrementPassenger(i, priceCount)"
                                    [disabled]="getPassengerCount(i) >= getMaxPassengers(i)"
                                  >
                                    <p class="mb-0" style="font-size: 20px; font-weight: 700;font-family: 'Rubik';">+</p>
                                  </button>
                                </div>

                                <!-- Select de edades para cualquier tipo que requiera edad -->
                                <div
                                  *ngIf="paxTypeRequiresAge(priceCount.paxType) && getPassengerCount(i) > 0"
                                  class="mt-1 d-flex align-items-start"
                                  style="gap: 10px; width: 100%;"
                                >
                                  <div style="width: 35%;">
                                    <span
                                      style="
                                        font-family: 'Rubik';
                                        font-size: 11px;
                                        font-weight: 400;
                                        line-height: 1.2;
                                        color: #000000;
                                      "
                                    >
                                      Edades de <br /> NIÑO ({{ getChildAgesLabel(i) }} años):
                                    </span>
                                  </div>

                                  <div class="row" style="width: 65%;">
                                    <div *ngFor="let child of getAgeInputs(i); let childIndex = index" class="col-3 mb-2">
                                      <div class="position-relative" style="width: 100%">
                                        <select
                                          class="form-control text-left pe-4"
                                          style="
                                            border-color: #ababab;
                                            border-radius: 10px;
                                            min-width: 50px;
                                            border-width: 1.2px;
                                            font-weight: 500;
                                            font-family: 'Poppins';
                                            padding: 4px 10px;
                                            -webkit-appearance: none;
                                            -moz-appearance: none;
                                            appearance: none;
                                          "
                                          [value]="getAgeForRange(i, childIndex)"
                                          (change)="updateAgeInRange(i, childIndex, +$event.target.value)"
                                        >
                                          <option
                                            *ngFor="let age of getAgeOptions(i)"
                                            [value]="age"
                                            [selected]="age === getAgeForRange(i, childIndex)"
                                          >
                                            {{ age }}
                                          </option>
                                        </select>
                                        <img
                                          src="../../../../../assets/img/app/little-icons/caret.svg"
                                          width="10"
                                          height="10"
                                          alt=""
                                          class="position-absolute"
                                          style="right: -7px; top: 50%; transform: translateY(-50%); pointer-events: none;"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="payload[0].categoriesId[0] === 9" style="width: 100%; padding: 40px; padding-left: 0px;">
              <div class="d-flex align-items-center pb-3" style="gap: 0.5em;">
                <img src="../../../../../assets/icons/search-result/tiempo_uso.svg" width="24px" alt="" />
                <p class="mb-0" style="font-family: &quot;Poppins&quot;, sans-serif; font-size: 19px; font-weight: 600">
                  Selección de horarios
                </p>
              </div>

              <div class="d-flex mt-2" style="height: 50px;">
                <div class="d-flex justify-content-between align-items-center" style="width: 100%">
                  <div class="d-flex flex-column" style="gap: 4px">
                    <p class="mb-0" style="font-family: &quot;Poppins&quot;, serif; font-size: 12px; font-weight: 400; line-height: 1">
                      Duración
                    </p>
                    <p class="mb-0" style="font-family: &quot;Poppins&quot;, serif; font-size: 12px; font-weight: 400; line-height: 1">
                      {{
                        _itemSelected?.availableDate?.arrivalDate
                          ? formatDateSpanish(_itemSelected.availableDate.arrivalDate)
                          : "Seleccionar fecha"
                      }}
                    </p>
                  </div>

                  <div class="custom-select-wrapper" style="width: 180px">
                    <select
                      #mySelectHour
                      (change)="selectHourTicket($event.target.value)"
                      class="form-control custom-select"
                      style="
                        height: 35px;
                        font-family: &quot;Poppins&quot;, sans-serif !important;
                        font-size: 14px !important;
                        font-weight: 600 !important;
                        color: #464646;
                      "
                      name=""
                      id=""
                    >
                      <option selected="true" disabled="true" value="null">--:--</option>
                      <!-- <option style="font-family: 'Poppins', sans-serif !important; font-size: 14px !important; font-weight: 600 !important;color: #464646;" value="null" disabled>{{ _itemSelected?.availableDate?.arrivalDate ? 'Seleccione el horario' : 'Selecciona una fecha del calendario'}}</option> -->
                      <ng-container *ngFor="let hour of hourDaySelected()">
                        <option
                          style="
                            font-family: &quot;Poppins&quot;, sans-serif !important;
                            font-size: 14px !important;
                            font-weight: 600 !important;
                            color: #464646;
                          "
                          value="{{ hour }}"
                        >
                          {{ hour }} hs.
                        </option>
                      </ng-container>
                    </select>

                    <i
                      class="fas fa-clock select-icon"
                      style="top: 50% !important"
                      [ngStyle]="{ color: clientSetting?.clients_setting_global?.color_main_1 }"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            *ngIf="payload[0].categoriesId[0] === 6 && comments && comments.length > 0"
            class="pb-5"
            style="padding-top: 30px; width: 100%; background-color: #ececec; margin-top: 40px"
          >
            <p style="font-family: &quot;Poppins&quot;, sans-serif; font-size: 19px; font-weight: 600; margin-left: 3em; margin-right: 3em">
              Reseñas destacadas
            </p>
            <div class="d-flex justify-content-center" style="gap: 1.5em; margin-left: 3.8em; margin-right: 3em">
              <ng-container *ngFor="let opinion of comments; let i = index">
                <ng-container *ngIf="i < 3">
                  <div
                    class="d-flex flex-column shadow"
                    style="background-color: white; border-radius: 20px; width: 100%; border: 1px solid #dddddd; padding: 30px;"
                  >
                    <div class="d-flex align-items-center" style="gap: 1.2em; margin-bottom: 8px">
                      <div>
                        <span style="width: 48px; height: 48px; border-radius: 50rem; background-color: #ececec; display: block"></span>
                      </div>
                      <div class="d-flex flex-column">
                        <p class="vehicle-middle-description" style="font-weight: 600; line-height: 1; margin-bottom: 5px; font-size: 14px
                        !important;">
                          {{ opinion?.booking_agent_name }} - {{ opinion?.booking_agency_name }}
                        </p>
                        <p class="mb-0 vehicle-middle-description" style="font-weight: 400; line-height: 1; font-size: 12px !important;">
                          Escrita el {{ opinion?.created_at | date: "dd-MMM-yyyy" }}
                        </p>
                      </div>
                    </div>

                    <div class="d-flex position-relative" style="gap: 0.2em; margin-left: -3px; margin-bottom: 16px">
                      <ng-container *ngFor="let element of assesmentComments; let i = index; let last = last">
                        <div
                          style="margin-top: 8px"
                          [ngStyle]="{
                            'background-color': i < opinion.assesment ? colors[opinion.assesment - 1] : 'transparent',
                            'margin-left': i > 0 ? '2px' : '',
                            width: '20px',
                            height: '20px',
                            'border-radius': '50%',
                            position: 'relative',
                            'z-index': 1,
                            display: 'flex',
                            'align-items': 'center',
                            'justify-content': 'center'
                          }"
                        >
                          <img [src]="getIconsComments(element)" style="width: 20px; transform: scale(1.2)" alt="" />
                        </div>
                      </ng-container>
                    </div>

                    <p class="mb-2 vehicle-middle-description" style="font-weight: 600; line-height: 1; font-size: 16px !important;">{{ opinion?.title }}</p>
                    <p class="mb-0 vehicle-middle-description" style="font-weight: 400; line-height: 1.2; font-size: 14px;">{{ opinion?.comments }}</p>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>

          <ng-container *ngIf="payload[0].categoriesId[0] === 6">
            <p
              style="
                font-family: &quot;Poppins&quot;, sans-serif;
                font-size: 19px;
                font-weight: 600;
                line-height: 1.2;
                margin-left: 3em;
                margin-right: 3em;
                margin-top: 40px;
              "
            >
              Seleccionar opción
            </p>

            <ng-container *ngFor="let option of optionsTour; let optionIndex = index">
              <div class="mb-2 d-flex flex-column" style="border: 1px solid #acacac; margin-left: 3.9em; margin-right: 3em">
                <div
                  class="d-flex justify-content-between align-items-start"
                  style="
                    background-color: #f4f4f4;
                    border-bottom: 1px solid #acacac;
                    padding-top: 25px;
                    padding-left: 30px;
                    padding-right: 30px;
                    padding-bottom: 25px;
                  "
                >
                  <!-- option title and check -->
                  <div class="d-flex align-items-center" style="gap: 15px; padding-top: 5px;">
                    <input type="checkbox" class="black-checkbox-title" />
                    <p class="mb-0" style="font-family: &quot;Poppins&quot;, sans-serif; font-size: 19px; font-weight: 700; line-height: 1">
                      {{ option?.option_name || tour?.title }}
                    </p>
                  </div>

                  <div class="d-flex flex-column align-items-end">
                    <div
                      class="mb-0 d-flex align-items-start"
                    >
                      <span style="margin-top: 4px; font-family: 'Rubik'; font-size: 20px; font-weight: 500; color: #34323b; line-height: 1.2;">{{ currencyAgency?.code }}</span>
                      <div class="d-flex flex-column" style="gap: 2px;">
                        <span style="font-family: 'Rubik', serif; font-size: 24px; line-height: 1.2; font-weight: 600; color: #0e0c18; line-height: 1.2;"
                          >&nbsp;{{
                            getSumPaxOption(option.optionId)
                              | currencyConverterPure: tour.additionalInfo.currency : currencyAgency.code : currencies
                              | number: "1.2-2"
                          }}</span>
                        <ng-container *ngFor="let pax of getPaxPricesWithTotals(option.optionId)">
                          <p
                            *ngIf="pax.passengerCount > 0"
                            class="mb-0 vehicle-middle-description"
                            style="font-size: 12px; font-weight: 500; line-height: 1.2; color: #666666;"
                          >
                            {{ pax.passengerCount }} {{ getPaxType(pax.paxType) }} x {{ currencyAgency?.code }}
                            {{
                              pax.unitPrice
                                | currencyConverterPure: tour.additionalInfo.currency : currencyAgency.code : currencies
                                | number: "1.2-2"
                            }}
                          </p>
                        </ng-container>
                        <p class="mb-0 vehicle-middle-description" style="font-size: 12px; font-weight: 400; line-height: 1.2; color: #666666;">
                          Impuesto incluido
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="d-flex flex-column px-4" style="padding-top: 32px; margin-left: 0.55em">
                  <div class="d-flex" style="gap: 1em; max-height: 208px; height: 100%">
                    <div
                      class="d-flex flex-row"
                      style="width: 100%; gap: 6.5px"
                      *ngIf="tour.additionalInfo?.images && tour.additionalInfo?.images.length > 0"
                    >
                      <ng-container *ngFor="let image of tour.additionalInfo?.images; let i = index">
                        <ng-container *ngIf="i === 0">
                          <div class="d-flex" style="height: 208px">
                            <picture class="w-100">
                              <img
                                [src]="image.thumbnail"
                                style="
                                  max-width: 383.5px;
                                  min-width: 383.5px;
                                  width: 100%;
                                  max-height: 208px;
                                  min-height: 208px;
                                  height: 100%;
                                  object-fit: fill;
                                "
                                alt="image_tour"
                              />
                            </picture>
                          </div>
                        </ng-container>
                      </ng-container>
                    </div>

                    <div class="d-flex flex-column justify-content-between" style="width: 100%">
                      <div
                        [ngStyle]="{
                          'flex-direction': getLanguageGuide(option).length > 1 ? 'row' : 'column',
                          'align-items': getLanguageGuide(option).length > 1 ? 'center' : 'start',
                          gap: getLanguageGuide(option).length > 1 ? '1em' : ''
                        }"
                        class="d-flex justify-content-center mb-2"
                      >
                        <div class="d-flex align-items-start" style="width: 100%">
                          <img src="../../../../../assets/icons/search-result/guia_language.svg" width="25px" alt="" />
                          <div class="d-flex flex-column" style="margin-left: 6px">
                            <p class="mb-0" style="font-family: &quot;Poppins&quot;, serif; font-size: 14px; font-weight: 600">Guía</p>
                            <p
                              *ngIf="getLanguageGuide(option).length > 1"
                              class="mb-0"
                              style="font-family: &quot;Poppins&quot;, serif; font-size: 12px; font-weight: 400; line-height: 1"
                            >
                              Idioma del guía
                            </p>
                            <p
                              *ngIf="getLanguageGuide(option).length === 1"
                              class="mb-0"
                              style="
                                font-family: &quot;Poppins&quot;, serif;
                                font-size: 12px;
                                font-weight: 400;
                                cursor: pointer;
                                line-height: 1;
                              "
                            >
                              {{ option.language ? "Guía en " + option.language : "Esta experiencia no cuenta con guía" }}
                            </p>
                          </div>
                        </div>

                        <div *ngIf="getLanguageGuide(option).length > 1" style="position: relative">
                          <select
                            #mySelectLanguage
                            class="form-control custom-select"
                            type="select"
                            style="
                              border-radius: 6px;
                              width: 165px;
                              height: 33px;
                              border: 1px solid #3f3f3f;
                              font-family: &quot;Poppins&quot;, serif;
                              font-size: 12px;
                              font-weight: 400;
                              line-height: 1;
                            "
                            (change)="selectLanguage($event.target.value)"
                          >
                            <option value="" selected="true" disabled="true">Seleccione idioma</option>
                            <option *ngFor="let language of getLanguageGuide(option)" [value]="language">
                              {{ language }}
                            </option>
                          </select>
                          <i
                            class="bi bi-caret-down-fill"
                            style="position: absolute; right: 0.8em; bottom: 15%; font-size: 0.75em; cursor: pointer"
                            (click)="mySelectLanguage.click()"
                          ></i>
                        </div>
                      </div>

                      <div class="d-flex flex-column justify-content-center">
                        <div class="d-flex align-items-start" style="width: 100%">
                          <img src="../../../../../assets/icons/search-result/tiempo_uso.svg" width="25px" alt="" />
                          <div class="d-flex flex-column" style="margin-left: 6px">
                            <p class="mb-0" style="font-family: &quot;Poppins&quot;, serif; font-size: 14px; font-weight: 600">
                              Duración {{ getDuration(option.duration) }}
                            </p>

                            <p
                              *ngIf="periodsActivities(tour?.additionalInfo?.tours?.options) !== ''"
                              class="mb-0"
                              style="font-family: &quot;Poppins&quot;, serif; font-size: 12px; font-weight: 400; line-height: 1"
                            >
                              Suele estar disponible por la {{ periodsActivities(tour?.additionalInfo?.tours?.options) }}
                            </p>
                            <p
                              *ngIf="periodsActivities(tour?.additionalInfo?.tours?.options) === ''"
                              class="mb-0"
                              style="font-family: &quot;Poppins&quot;, serif; font-size: 12px; font-weight: 400; line-height: 1"
                            >
                              <span
                                *ngIf="
                                  tour?.scheduling &&
                                  tour?.scheduling &&
                                  tour?.scheduling.length > 0 &&
                                  tour?.scheduling[0]?.opened &&
                                  tour?.scheduling[0]?.opened.length > 0
                                "
                              >
                                Abierto desde {{ tour?.scheduling[0].opened[0].openingTime }} hs. hasta
                                {{ tour?.scheduling[0].opened[0].closeTime }} hs.
                              </span>
                              <span *ngIf="tour?.scheduling.length === 0">
                                Suele estar disponible por la {{ periodsActivities(tour?.additionalInfo?.tours?.options) }}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>

                      <div class="d-flex flex-column justify-content-center">
                        <div class="d-flex align-items-start" style="width: 100%">
                          <img src="../../../../../assets/icons/search-result/tour/gps.svg" width="22px" alt="" />
                          <div class="d-flex flex-column" style="margin-left: 7px">
                            <p class="mb-0" style="font-family: &quot;Poppins&quot;, serif; font-size: 14px; font-weight: 600">
                              Punto de encuentro en {{ tour?.additionalInfo?.location }}
                            </p>
                            <p
                              class="mb-0"
                              [ngStyle]="{ color: clientSetting?.clients_setting_global?.color_main_1 }"
                              style="
                                font-family: 'Rubik', serif;
                                font-size: 13px;
                                font-weight: 400;
                                cursor: pointer;
                                filter: brightness(0.85);
                              "
                              (click)="tab = 'maps'"
                            >
                              &nbsp;Ver en mapa<span
                                *ngIf="tour.additionalInfo?.routes && tour.additionalInfo?.routes.length > 0"
                                style="cursor: pointer"
                                [ngStyle]="{ color: clientSetting?.clients_setting_global?.color_main_1 }"
                                (click)="tab = 'info'"
                                >&nbsp;- Ver rutas</span
                              >
                            </p>
                          </div>
                        </div>
                      </div>

                      <div>
                        <div class="d-flex align-items-start" style="width: 100%">
                          <img src="../../../../../assets/icons/search-result/tour/gps.svg" width="22px" alt="" />
                          <div class="d-flex align-items-center" style="margin-left: 7px">
                            <p class="mb-0" style="font-family: &quot;Poppins&quot;, serif; font-size: 14px; font-weight: 600">
                              Tour
                              <span style="text-transform: capitalize !important">{{
                                option?.optionType ? option?.optionType : "N/A"
                              }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <p
                    class="description-tour"
                    style="
                      font-family: &quot;Rubik&quot;, sans-serif;
                      font-size: 15px;
                      font-weight: 400;
                      line-height: 1.3;
                      margin-top: 30px;
                      padding-right: 2.5em;
                      color: #272729;
                      margin-top: 20px;
                      margin-bottom: 20px;
                    "
                  >
                    {{ (tour.additionalInfo.extra_info ? tour.additionalInfo.extra_info : "") | truncate: 200 : "  " }}
                    <a
                      (click)="moreDescription()"
                      style="cursor: pointer; font-weight: 700"
                      *ngIf="tour.additionalInfo.extra_info != ''"
                      class="more"
                      >...Leer más</a
                    >
                  </p>

                  <div
                    *ngIf="option?.routes && option?.routes.length > 0"
                    class="d-flex flex-column mt-4"
                    style="border-top: 2px dotted #ababab; padding-top: 25px; padding-bottom: 15px"
                    [ngStyle]="{
                      'padding-bottom':
                        isRouteVisibleForOption(option, optionIndex) &&
                        getStopsRouteForOption(option, optionIndex).length > 0
                          ? '0px'
                          : '15px'
                    }"
                  >
                    <div style="width: 30%">
                      <p style="font-family: &quot;Poppins&quot;, serif; font-size: 16px; font-weight: 600">Cronogramas</p>
                    </div>

                    <div class="d-flex flex-column" style="width: 100%; margin-bottom :20px;">
                      <ng-container *ngFor="let route of option?.routes; let routeIndex = index">
                        <div
                          class="d-flex justify-content-between align-items-center"
                          style="padding: 14px 10px 14px 22px; border: 1px solid #ececec"
                        >
                          <p class="mb-0 vehicle-middle-description" style="font-weight: 500; line-height: 1.2; font-size: 13px !important;
                          font-family: 'Poppins';">
                            {{ route.description }}: {{ route?.duration_hours }}:{{ route?.duration_minutes }} hs.
                          </p>
                          <button
                            type="button"
                            style="
                              font-family: 'Poppins', sans-serif;
                              font-size: 13px;
                              font-weight: 500;
                              border: none;
                              background-color: transparent;
                            "
                            [ngStyle]="{ color: clientSetting?.clients_setting_global?.color_main_1 }"
                            (click)="toggleRoute(option, optionIndex, option?.routes, routeIndex)"
                          >
                            {{ getSelectedRouteIndexForOption(option, optionIndex) === routeIndex ? "Ocultar" : "Ver" }} detalle
                          </button>
                        </div>
                      </ng-container>
                    </div>
                  </div>

                  <div style="margin-bottom: 35px;" *ngIf="isRouteVisibleForOption(option, optionIndex) && getStopsRouteForOption(option, optionIndex).length > 0">
                    <div class="d-flex p-3" style="gap: 1em; border: 1px solid #ececec">
                      <div class="route-timeline" style="width: 50%; height: fit-content">
                        <div *ngFor="let stop of getStopsRouteForOption(option, optionIndex); let j = index" class="timeline-stop">
                          <div
                            class="stop-circle d-flex justify-content-center align-items-center"
                            style="border: 2px solid #000000; width: 35px !important; height: 35px !important;"
                            [ngStyle]="{ 'background-color': clientSetting?.clients_setting_global?.color_main_1 }"
                          >
                            <span class="stop-order" style="color: #000000; font-size: 14px !important;">
                              {{ stop.order }}
                            </span>
                          </div>

                          <div class="stop-info" (click)="selectStop(stop, option, optionIndex)" style="cursor: pointer; border-radius: 5px; padding: 10px !important;" [ngStyle]="getStopCircleStyles(stop)">
                            <span *ngIf="stop?.description" class="stop-description" style="font-family: 'Rubik' !important; font-size: 13px; font-weight: 600 !important; line-height: 1.3;">&nbsp;{{ stop.description }}</span>
                            <span *ngIf="stop?.duration_hours && stop?.duration_minutes" class="stop-description" style="font-family: 'Rubik'; font-size: 12px; line-height: 1.3;"
                              >&nbsp;Duración: {{ stop?.duration_hours }}:{{ stop?.duration_minutes }} hs.</span
                            >
                            <span *ngIf="stop?.duration_hours && stop?.duration_minutes" class="stop-description" style="font-family: 'Rubik'; font-size: 12px; line-height: 1.3;"
                              >&nbsp;Hora: 8:40 hs. - 9:05 hs.</span>
                            <span class="stop-city mt-1" style="font-family: 'Poppins'; font-size: 9px;"></span>
                          </div>
                        </div>
                      </div>

                      <div *ngIf="isRouteVisibleForOption(option, optionIndex)" style="width: 100%">
                        <app-map-view
                          [coordinatesArr]="getStopsRouteForOption(option, optionIndex)"
                          [selectedStopIndex]="getSelectedRouteIndexForOption(option, optionIndex)"
                          (stopSelected)="selectStop($event, option, optionIndex)"
                          mapMode="route"
                          [routeColor]="clientSetting?.clients_setting_global?.color_main_1"
                        >
                        </app-map-view>
                      </div>
                    </div>
                  </div>

                  <div
                    class="d-flex"
                    style="
                      border-top: 2px dotted #ababab;
                      border-bottom: 2px dotted #ababab;
                      gap: 1em;
                      padding-top: 25px;
                      padding-bottom: 25px;
                    "
                  >
                    <div class="d-flex flex-column" style="width: 100%">
                      <p class="mb-1" style="font-family: &quot;Poppins&quot;, serif; font-size: 16px; font-weight: 600">Incluye</p>
                      <ng-container
                        *ngIf="
                          tour.additionalInfo?.tours?.amenities &&
                          tour.additionalInfo?.tours?.amenities.included &&
                          tour.additionalInfo?.tours?.amenities.included.length > 0
                        "
                      >
                        <ng-container *ngFor="let include of tour.additionalInfo?.tours?.amenities.included">
                          <p
                            class="mb-1"
                            style="
                              font-family: &quot;Rubik&quot;, serif;
                              font-size: 14px;
                              font-weight: 400;
                              cursor: pointer;
                              line-height: 20px;
                            "
                          >
                            • {{ include.description || "Falta descripción" }}
                          </p>
                        </ng-container>
                      </ng-container>
                      <ng-container
                        *ngIf="
                          tour.additionalInfo?.tours?.amenities &&
                          tour.additionalInfo?.tours?.amenities.included &&
                          tour.additionalInfo?.tours?.amenities.included.length === 0
                        "
                      >
                        <p
                          class="mb-1"
                          style="
                            font-family: &quot;Poppins&quot;, serif;
                            font-size: 12px;
                            font-weight: 400;
                            cursor: pointer;
                            line-height: 20px;
                          "
                        >
                          N/A
                        </p>
                      </ng-container>
                    </div>
                    <div class="d-flex flex-column" style="width: 97%">
                      <p class="mb-1" style="font-family: &quot;Poppins&quot;, serif; font-size: 16px; font-weight: 600">No incluye</p>
                      <ng-container
                        *ngIf="
                          tour.additionalInfo?.tours?.amenities &&
                          tour.additionalInfo?.tours?.amenities.notIncluded &&
                          tour.additionalInfo?.tours?.amenities.notIncluded.length > 0
                        "
                      >
                        <ng-container *ngFor="let include of tour.additionalInfo?.tours?.amenities.notIncluded">
                          <p
                            class="mb-1"
                            style="
                              font-family: &quot;Rubik&quot;, serif;
                              font-size: 14px;
                              font-weight: 400;
                              cursor: pointer;
                              line-height: 20px;
                            "
                          >
                            • {{ include.description || "Falta descripción" }}
                          </p>
                        </ng-container>
                      </ng-container>
                      <ng-container
                        *ngIf="
                          tour.additionalInfo?.tours?.amenities &&
                          tour.additionalInfo?.tours?.amenities.notIncluded &&
                          tour.additionalInfo?.tours?.amenities.notIncluded.length === 0
                        "
                      >
                        <p
                          class="mb-1"
                          style="
                            font-family: &quot;Poppins&quot;, serif;
                            font-size: 12px;
                            font-weight: 400;
                            cursor: pointer;
                            line-height: 20px;
                          "
                        >
                          N/A
                        </p>
                      </ng-container>
                    </div>
                  </div>

                  <div
                    *ngIf="option.questions && option.questions.length > 0"
                    class="d-flex flex-column py-3"
                    style="border-bottom: 2px dotted #ababab"
                  >
                    <p class="mb-1" style="font-family: &quot;Poppins&quot;, serif; font-size: 16px; font-weight: 600">Requisitos</p>
                    <ng-container *ngFor="let question of option.questions">
                      <p
                        class="mb-1"
                        style="font-family: &quot;Rubik&quot;, serif; font-size: 14px; font-weight: 400; cursor: pointer; line-height: 1"
                      >
                        • {{ getQuestionsName(question.code) || "Falta descripción" }}
                      </p>
                    </ng-container>
                  </div>

                  <ng-container *ngIf="hourSelectHidden">
                    <div class="d-flex mt-4">
                      <div class="d-flex flex-column justify-content-center" style="width: 100%">
                        <p
                          class="mb-0"
                          style="font-family: &quot;Poppins&quot;, serif; font-size: 16px; font-weight: 600; line-height: 1.4"
                        >
                          Seleccionar hora
                        </p>
                        <p
                          *ngIf="tour?.scheduling && tour?.scheduling.length > 0 && tour?.scheduling[0].duration"
                          class="mb-0"
                          style="font-family: &quot;Poppins&quot;; font-size: 12px; font-weight: 500; margin-bottom: 5px; line-height: 20px"
                        >
                          Duración tour {{ tour?.scheduling[0].duration.value | number: "1.0-0" }}
                          {{ tour?.scheduling[0].duration?.metric === "HOURS" ? "hs." : "min." }}
                          <span style="text-transform: lowercase">{{
                            tour?.scheduling[0].duration?.description ? tour?.scheduling[0].duration?.description : ""
                          }}</span>
                        </p>

                        <p
                          class="mb-0"
                          style="font-family: &quot;Poppins&quot;; font-size: 12px; font-weight: 500; line-height: 20px;"
                          [ngStyle]="{ color: _itemSelected?.availableDate?.arrivalDate ? 'black' : ' #ed3b5b' }"
                        >
                          {{
                            _itemSelected?.availableDate?.arrivalDate
                              ? getDate(_itemSelected.availableDate.arrivalDate)
                              : ""
                          }}
                        </p>
                      </div>
                      <div style="width: 95%">
                        <div class="custom-select-wrapper" style="width: 200px">
                          <select
                            #mySelectHour
                            class="form-control custom-select"
                            type="select"
                            style="border-radius: 6px; height: 48px !important; font-size: 18px !important; font-weight: 500 !important; color: #000000; font-family: 'Poppins';"
                            (change)="hourSelectedFX($event.target.value)"
                          >
                            <ng-container *ngIf="getHoursAvailTickets(option).length === 1">
                              <option value="{{ getHoursAvailTickets(option)[0] }}">{{ getHoursAvailTickets(option)[0] }} hs.</option>
                            </ng-container>
                            <ng-container *ngIf="getHoursAvailTickets(option).length > 1">
                              <option selected="true" disabled="true" value="null">--:--</option>
                              <option *ngFor="let hour of getHoursAvailTickets(option)" [value]="hour">{{ hour }} hs.</option>
                            </ng-container>
                          </select>

                          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 450 450.1"
                            style="
                              width: 20px;
                              position: absolute;
                              right: 20px;
                              top: 15px;
                            " xml:space="preserve"> <style type="text/css"> .st0{fill:none;stroke:#000000;stroke-width:42;stroke-miterlimit:10;} .st1{fill:none;stroke:#000000;stroke-width:42;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} </style> <g id="Capa_1"> <circle [ngStyle]="{ 'stroke': clientSetting?.clients_setting_global?.color_main_1 }"   class="st0" cx="225" cy="225.1" r="204"/> <polyline [ngStyle]="{ 'stroke': clientSetting?.clients_setting_global?.color_main_1 }" class="st1" points="137.1,225 225.3,225 225.3,104.8 	"/> </g> <g id="Layer_2"> </g> </svg>
                        </div>
                      </div>
                    </div>
                  </ng-container>

                  <div class="d-flex mt-4 align-items-center pl-2" style="background-color: #f0f0f0; gap: 10px; height: 40px;">
                    <img src="../../../../../assets/icons/calendario.svg" width="20px" height="20px" alt="" />

                    <ng-container *ngIf="option.rateClass === 'R'">
                      <p
                        class="mb-0 vehicle-middle-description"
                        style="font-weight: 500; line-height: 1; margin-bottom: 5px; font-size: 14px !important; font-family: 'Poppins' !important;"
                        [ngStyle]="{
                          color: _itemSelected?.availableDate?.arrivalDate ? 'black' : '#ed3b5b',
                          'font-weight': _itemSelected?.availableDate?.arrivalDate ? '500' : '400'
                        }"
                      >
                        {{
                          _itemSelected?.availableDate?.arrivalDate
                            ? "Cancela antes del " +
                              (getCancellationPrice(option.cancellationPolicies, option.cancellation_policy) | date: "dd/MM/yyyy") +
                              " para reembolso"
                            : "Seleccionar fecha en calendario"
                        }}
                      </p>
                    </ng-container>
                    <ng-container *ngIf="option.rateClass === 'NR'">
                      <p class="mb-0 vehicle-middle-description" style="font-weight: 600; line-height: 1; margin-bottom: 5px">
                        Cancelación con 100% de cargo
                      </p>
                    </ng-container>
                  </div>

                  <ng-container *ngIf="getAmenitieTrasnsfer(tour?.additionalInfo?.tours?.extras, 'valid')">
                    <ng-container *ngIf="tour?.additionalInfo?.tours?.extras && tour?.additionalInfo?.tours?.extras.length > 0">
                      <div class="mt-5">
                        <p class="mb-2" style="font-family: 'Poppins', serif; font-size: 17px !important; font-weight: 600">
                          Adicionales
                        </p>
                        <ng-container *ngFor="let amenity of tour?.additionalInfo?.tours?.extras; let i = index">
                          <ng-container *ngIf="amenity?.details && !amenity?.details?.transfer_type_catalogue_id">
                            <div class="d-flex mb-1" style="gap: 0.25em">
                              <input
                                type="checkbox"
                                class="black-checkbox"
                                [checked]="addonsIsSelected(option, amenity)"
                                (click)="toggleAddons($event, option, amenity, amenity.totalPriceProf)"
                              />
                              <div class="d-flex">
                                <p class="mb-0" style="font-family: 'Poppins', serif; font-size: 14px !important">
                                  {{ amenity.description }}
                                  <span style="font-weight: 600">
                                    ({{ tour.additionalInfo?.currency }} {{ amenity.totalPriceProf | number: "1.2-2" }})
                                    <span *ngIf="currencyAgency?.code !== tour.additionalInfo?.currency">
                                      ({{ currencyAgency?.code }}
                                      {{
                                        amenity.totalPriceProf
                                          | currencyConverterPure: tour.additionalInfo?.currency : currencyAgency?.code : currencies
                                          | number: "1.2-2"
                                      }})
                                    </span>
                                  </span>
                                </p>
                                <usb-tooltip-convert-amount
                                  *ngIf="currencyAgency?.code !== tour.additionalInfo?.currency"
                                  [clientsSettingAppBooking]="clientSetting"
                                  [currencyProduct]="tour.additionalInfo?.currency"
                                  [valueProduct]="amenity.totalPriceProf"
                                >
                                </usb-tooltip-convert-amount>
                              </div>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="amenity?.details && amenity?.details?.transfer_type_catalogue_id">
                            <p class="mt-5" style="font-family: 'Poppins', serif; font-size: 17px !important; font-weight: 600">
                              Agregar {{ amenity.description }}
                            </p>

                            <div class="d-flex">
                              <div class="w-100 d-flex align-items-center" style="gap: 0.5em">
                                <label class="mb-0" style="margin-top: 6px">
                                  <input
                                    type="checkbox"
                                    class="black-checkbox"
                                    (change)="isTransferSelected($event, true, option, amenity, amenity.totalPriceProf)"
                                    [checked]="isTransferSelect"
                                  />
                                </label>
                                <p class="mb-0 vehicle-middle-description" style="font-weight: 600; font-family: 'Poppins'; font-size: 14px;">Con traslado</p>
                              </div>
                              <div class="w-100 d-flex align-items-center" style="gap: 0.5em">
                                <label class="mb-0" style="margin-top: 6px">
                                  <input
                                    type="checkbox"
                                    class="black-checkbox"
                                    (change)="isTransferSelected($event, false, option, amenity, amenity.totalPriceProf)"
                                    [checked]="!isTransferSelect"
                                  />
                                </label>
                                <p class="mb-0 vehicle-middle-description" style="font-weight: 600; font-family: 'Poppins'; font-size: 14px;">Sin traslado</p>
                              </div>
                            </div>

                            <div *ngIf="isTransferSelect" class="transfer-details animate__animated animate__fadeIn mt-3">
                              <div class="transfer-card p-3" style="background-color: #f8f9fa; border-radius: 6px">
                                <div class="d-flex align-items-center mb-2">
                                  <h6 class="mb-0" style="font-weight: 600">Detalles del traslado</h6>
                                </div>

                                <div class="row mb-2">
                                  <div class="col-6">
                                    <small class="text-muted">Recogida:</small>
                                    <p class="mb-0 small" style="font-weight: 500">
                                      <i class="fas fa-clock me-1"></i>
                                      {{
                                        getAmenitieTrasnsfer(tour?.additionalInfo?.tours?.extras, "transfer")?.details?.pickup_time_from
                                          | slice: 0 : 5
                                      }}
                                      hs
                                    </p>
                                  </div>
                                  <div class="col-6">
                                    <small class="text-muted">Llegada:</small>
                                    <p class="mb-0 small" style="font-weight: 500">
                                      <i class="fas fa-hourglass-half me-1"></i>
                                      {{
                                        getAmenitieTrasnsfer(tour?.additionalInfo?.tours?.extras, "transfer")?.details?.pickup_time_to
                                          | slice: 0 : 5
                                      }}
                                      hs antes
                                    </p>
                                  </div>
                                </div>

                                <div class="mb-2">
                                  <small class="text-muted">Indicaciones para la recogida:</small>
                                  <p class="mb-0 small" style="font-weight: 500">
                                    <i class="fas fa-info-circle me-1"></i>
                                    {{
                                      getAmenitieTrasnsfer(tour?.additionalInfo?.tours?.extras, "transfer")?.details?.pickup_indication ||
                                        "Sin indicaciones específicas"
                                    }}
                                  </p>
                                </div>

                                <div class="mb-2">
                                  <small class="text-muted">Indicaciones para el regreso:</small>
                                  <p class="mb-0 small" style="font-weight: 500">
                                    <i class="fas fa-info-circle me-1"></i>
                                    {{
                                      getAmenitieTrasnsfer(tour?.additionalInfo?.tours?.extras, "transfer")?.details?.dropoff_indication ||
                                        "Sin indicaciones específicas"
                                    }}
                                  </p>
                                </div>

                                <div class="d-flex align-items-center mt-3 pt-2" style="border-top: 1px dashed #ddd">
                                  <span class="small text-muted">Costo adicional del traslado:&nbsp;</span>
                                  <p class="mb-0 small" style="font-weight: 600">
                                    {{ currencyAgency.code }}
                                    {{
                                      getAmenitieTrasnsfer(tour?.additionalInfo?.tours?.extras, "transfer")?.totalPrice
                                        | currencyConverterPure: tour.additionalInfo.currency : currencyAgency.code : currencies
                                        | number: "1.2-2"
                                    }}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                        </ng-container>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>

                <div
                  *ngIf="!validPaymentConditionAgencyAvailable(option.rateClass)"
                  class="d-flex justify-content-end py-2 mr-4"
                  style="margin-bottom: 35px; margin-top: 25px"
                >
                  <p class="mb-0" style="font-family: &quot;Poppins&quot;; font-size: 13px; font-weight: 500; color: #ed3b5b">
                    No es posible seleccionar un producto no reembolsable debido a las condiciones de pago de la agencia
                  </p>
                </div>

                <div
                  class="d-flex justify-content-end py-2 mr-4"
                  style="margin-bottom: 35px; margin-top: 25px"
                  *ngIf="!isOptionAvailable(option) && validPaymentConditionAgencyAvailable(option.rateClass)"
                >
                  <p class="mb-0" style="font-family: &quot;Poppins&quot;; font-size: 13px; font-weight: 500; color: #ed3b5b">
                    {{ getAvailabilityMessage(option) }}
                  </p>
                </div>

                <div
                  *ngIf="isOptionAvailable(option) && validPaymentConditionAgencyAvailable(option.rateClass)"
                  class="flex-row py-2 mr-4"
                  style="margin-bottom: 35px; margin-top: 25px"
                >
                  <button
                    type="button"
                    class="pull-right btn btn-continue cursor-pointer"
                    style="
                      color: #000000;
                      text-transform: capitalize !important;
                      font-size: 16px !important;
                      padding: 10px 20px;
                      width: 175px !important;
                      font-weight: 600 !important;
                      font-family: 'Rubik';
                    "
                    [ngStyle]="{ 'background-color': clientSetting?.clients_setting_global?.color_main_1 }"
                    (click)="continue(option)"
                  >
                    {{ !continueValidProcess ? "Procesando" : "Seleccionar" }}
                  </button>
                </div>
              </div>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="payload[0].categoriesId[0] == 9">
            <div
              class="d-flex flex-column justify-content-center mt-4 mb-5"
              style="
                min-height: 200px;
                border-radius: 6px;
                box-shadow: 2px 4px 10px 0px rgba(0, 0, 0, 0.1);
                margin-left: 3.5em;
                margin-right: 2.8em;
              "
            >
              <div class="d-flex align-items-center pb-3 pt-1" style="gap: 0.5em; margin-right: 2.8em; margin-left: 2.5em">
                <img src="../../../../assets/img/app/categories-search-box/combi-ticket.svg" width="24px" alt="" />
                <p class="mb-0" style="font-family: &quot;Poppins&quot;, sans-serif; font-size: 19px; font-weight: 600">
                  Seleccionar tickets
                </p>
              </div>

              <div class="mt-4 pb-5" style="margin-right: 2.8em; margin-left: 2.5em">
                <!-- Mensaje informativo actualizado -->
                <div *ngIf="_itemSelected?.availableDate?.arrivalDate && hourSelected" class="mb-2 small text-muted">
                  <ng-container *ngIf="getOptionsTickets(optionsTour).length === 1">
                    Este ticket se aplicará a todos los {{ totalPassengers }} pasajeros.
                  </ng-container>
                  <ng-container *ngIf="getOptionsTickets(optionsTour).length > 1">
                    Puedes seleccionar hasta {{ totalPassengers }} tickets.
                  </ng-container>
                </div>

                <mat-select
                  #mySelect
                  placeholder="{{ getPlaceHolderTickets() }}"
                  multiple
                  class="center-placeholder-select form-control"
                  style="
                    width: 100%;
                    font-family: &quot;Poppins&quot;, sans-serif !important;
                    font-size: 14px !important;
                    font-weight: 600 !important;
                    color: #464646;
                  "
                  (selectionChange)="toggleTap($event)"
                  (opened)="onSelectOpened()"
                  (closed)="onSelectClosed()"
                  [disabled]="!_itemSelected?.availableDate?.arrivalDate && !hourSelected"
                  [panelClass]="'wide-panel'"
                >
                  <mat-option
                    value="null"
                    disabled
                    style="
                      font-family: &quot;Poppins&quot;, sans-serif !important;
                      font-size: 14px !important;
                      font-weight: 600 !important;
                      color: #464646;
                    "
                  >
                    {{
                      _itemSelected?.availableDate?.arrivalDate
                        ? hourSelected
                          ? "Seleccione una opción"
                          : "Seleccione un horario"
                        : ""
                    }}
                  </mat-option>

                  <ng-container *ngIf="_itemSelected?.availableDate?.arrivalDate && hourSelected">
                    <mat-option
                      *ngFor="let option of getOptionsTickets(optionsTour); let i = index"
                      [value]="option"
                      style="
                        font-family: &quot;Poppins&quot;, sans-serif !important;
                        font-size: 14px !important;
                        font-weight: 600 !important;
                        color: #464646;
                      "
                    >
                      <ng-container *ngIf="option?.language">
                        <img
                          [src]="getFlagByLanguageName(option?.language)"
                          style="width: 20px; height: 16px; border-radius: 2px; object-fit: cover"
                          [tooltip]="option?.language"
                          placement="bottom"
                          alt="flag"
                        />
                      </ng-container>
                      <span
                        class="ml-2"
                        style="
                          font-family: &quot;Poppins&quot;, sans-serif !important;
                          font-size: 14px !important;
                          font-weight: 600 !important;
                          color: #464646;
                        "
                        >{{ option?.option_name }} - ({{ currencyAgency?.code }}
                        {{
                          getBasePriceForOption(option)
                            | currencyConverterPure: tour.additionalInfo.currency : currencyAgency.code : currencies
                            | number: "1.2-2"
                        }})</span
                      >
                    </mat-option>
                  </ng-container>

                  <mat-option
                    *ngIf="!getOptionsTickets(optionsTour).length"
                    disabled
                    style="
                      font-family: &quot;Poppins&quot;, sans-serif !important;
                      font-size: 14px !important;
                      font-weight: 600 !important;
                      color: #464646;
                    "
                  >
                    No hay opciones disponibles
                  </mat-option>
                </mat-select>
              </div>

              <!-- Lista de tickets seleccionados -->
              <div
                *ngIf="ticketsSelected && ticketsSelected.length > 0"
                class="d-flex mx-auto mb-3"
                style="width: 100%; margin-right: 2.8em; margin-left: 2.5em"
                #containingDiv
              >
                <div class="mx-auto" style="display: flex; flex-direction: column; width: 100%" #selectedRoomsDiv>
                  <div class="d-flex align-items-center pb-3" style="margin-right: 2.8em; margin-left: 2.5em; gap: 0.5em">
                    <img #icon src="../../../../assets/icons/itinerary/persona.svg" width="24px" alt="" />
                    <p class="mb-0" style="font-family: &quot;Poppins&quot;, sans-serif; font-size: 19px; font-weight: 600">
                      Asignar pasajero
                    </p>
                  </div>
                  <div
                    *ngIf="_itemSelected?.availableDate?.arrivalDate && hourSelected"
                    class="mb-2 small text-muted"
                    style="margin-right: 3em; margin-left: 2.8em"
                  >
                    <ng-container *ngIf="getOptionsTickets(optionsTour).length > 1">
                      Cada ticket debe asignarse a un pasajero específico.
                    </ng-container>
                  </div>
                  <div *ngFor="let selectedTicket of ticketsSelected; let currentTicketIndex = index">
                    <div
                      class="d-flex align-items-center justify-content-between mb-2 px-3"
                      style="background-color: #f8f8f8; border-radius: 6px; margin-right: 2.8em; margin-left: 2.5em; position: relative"
                    >
                      <div class="d-flex flex-column py-2" style="flex: 1">
                        <div class="d-flex alig-items-center" style="gap: 1em">
                          <div class="d-flex align-items-center pr-2" style="gap: 0.75em; max-width: 150px; width: 100%">
                            <ng-container *ngIf="selectedTicket?.language">
                              <img
                                [src]="getFlagByLanguageName(selectedTicket?.language)"
                                style="width: 20px; height: 16px; border-radius: 2px; object-fit: cover"
                                [tooltip]="selectedTicket?.language"
                                placement="bottom"
                                alt="flag"
                              />
                            </ng-container>

                            <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif; font-size: 12px; font-weight: 600">
                              {{ selectedTicket.option_name }}
                            </p>
                          </div>

                          <mat-select
                            multiple
                            class="center-placeholder-select form-control"
                            style="max-width: 300px; width: 100%; font-family: &quot;Rubik&quot;, serif; font-size: 12px; font-weight: 500"
                            [value]="getSelectedPassengerIndices(currentTicketIndex)"
                            (selectionChange)="onPassengerSelectionChange($event, currentTicketIndex)"
                          >
                            <mat-option
                              class="mb-0"
                              style="font-family: &quot;Rubik&quot;, serif; font-size: 12px; font-weight: 400"
                              *ngFor="let pax of availablePassengers; let paxIndex = index"
                              [value]="paxIndex"
                              [disabled]="isPassengerAlreadyAssignedToOtherTicket(pax, currentTicketIndex)"
                            >
                              {{ getPaxTypeLabel(pax.type) }}
                              {{
                                pax.age !== undefined && pax.age !== null && pax.age !== ""
                                  ? "(" + pax.age + " años)"
                                  : pax.ageRange?.from !== undefined && pax.ageRange?.from !== null && pax.ageRange?.from !== ""
                                    ? "(desde " + pax.ageRange?.from + "+ años)"
                                    : ""
                              }}
                              <span style="font-weight: 600">
                                - {{ currencyAgency?.code }}
                                {{
                                  getPriceForPaxTypeTickets(selectedTicket, pax.type)
                                    | currencyConverterPure: tour.additionalInfo.currency : currencyAgency.code : currencies
                                    | number: "1.2-2"
                                }}</span
                              >
                            </mat-option>
                          </mat-select>
                        </div>

                        <!-- Mostrar pasajeros asignados -->

                        <div
                          *ngIf="selectedTicket.assignedPassengers && selectedTicket.assignedPassengers.length > 0"
                          class="mt-4 d-flex flex-column align-items-center pt-4 pb-3"
                          style="border-top: 2px solid #ececec; gap: 1em"
                        >
                          <div
                            *ngFor="let pax of selectedTicket.assignedPassengers; let paxIdx = index"
                            class="d-flex align-items-center"
                            style="width: 100%"
                          >
                            <div class="d-flex align-items-center pr-2" style="gap: 0.75em; max-width: 175px; width: 100%">
                              <ng-container *ngIf="selectedTicket?.language">
                                <img
                                  [src]="getFlagByLanguageName(selectedTicket?.language)"
                                  style="width: 20px; height: 16px; border-radius: 2px; object-fit: cover"
                                  [tooltip]="selectedTicket?.language"
                                  placement="bottom"
                                  alt="flag"
                                />
                              </ng-container>

                              <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif; font-size: 12px; font-weight: 600">
                                {{ selectedTicket.option_name }}
                              </p>
                            </div>
                            <div class="d-flex align-items-center" style="max-width: 300px; width: 100%; gap: 18px">
                              <p class="mb-1" style="font-family: &quot;Rubik&quot;, serif; font-size: 12px; font-weight: 400">
                                {{ getPaxTypeLabel(pax.type) }}
                                {{
                                  pax.age !== undefined && pax.age !== null && pax.age !== ""
                                    ? "(" + pax.age + " años)"
                                    : pax.ageRange?.from !== undefined && pax.ageRange?.from !== null && pax.ageRange?.from !== ""
                                      ? "(desde " + pax.ageRange?.from + "+ años)"
                                      : ""
                                }}

                                <span style="font-weight: 600">
                                  - ({{ currencyAgency?.code }}
                                  {{
                                    getPriceForPaxTypeTickets(selectedTicket, pax.type)
                                      | currencyConverterPure: tour.additionalInfo.currency : currencyAgency.code : currencies
                                      | number: "1.2-2"
                                  }})</span
                                >
                              </p>
                              <span
                                style="
                                  margin-top: 5px;
                                  font-weight: 400;
                                  color: #d60159;
                                  cursor: pointer;
                                  font-size: 12px;
                                  margin-bottom: 0.45rem;
                                "
                                tooltip="Eliminar pasajero"
                                placement="bottom"
                                (click)="removePaxFromTicket(currentTicketIndex, paxIdx, pax)"
                                ><i class="bi bi-x-circle" style="font-size: 1.1rem"></i
                              ></span>
                            </div>
                          </div>
                        </div>

                        <!-- <div *ngIf="!selectedTicket.assignedPassengers || selectedTicket.assignedPassengers.length === 0"
                class="small text-warning mt-2 ms-4">
              Sin pasajeros asignados
            </div> -->

                        <!-- Total del ticket -->
                        <!-- <div class="mb-0 mt-2" style="font-family: 'Rubik', serif; font-size: 13px; font-weight: 500;">
              Total: {{ currencyAgency?.code }} {{ getSumPaxOption(selectedTicket.optionId, selectedTicket)  | currencyConverterPure: tour.additionalInfo.currency: currencyAgency.code: currencies | number: '1.2-2' }}
            </div> -->
                      </div>

                      <div style="position: absolute; right: 0; top: 0; display: flex">
                        <div
                          class="btn-delete-room"
                          tooltip="Eliminar ticket"
                          placement="bottom"
                          (click)="removeTicketSelected(currentTicketIndex)"
                        >
                          <svg
                            version="1.1"
                            id="Layer_2_00000146472910104976704670000005604375476625682068_"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            viewBox="0 0 512 512"
                            style="fill: #ff3f63; width: 25px"
                            xml:space="preserve"
                          >
                            <path
                              d="M422.1,82H388V53c0-29.3-23.7-53-53-53H177c-29.3,0-53,23.7-53,53v29H90c-18.8,0-34.1,15.3-34.1,34.1v54.6
                        c0,9.4,7.6,17.1,17.1,17.1l0,0h10.3v273c0,28.3,22.9,51.2,51.2,51.2h243.2c28.3,0,51.2-22.9,51.2-51.2V187.7h10.4
                        c9.4,0,17.1-7.6,17.1-17c0,0,0,0,0,0v-54.5C456.2,97.3,440.9,82,422.1,82z M158.1,53c0-10.4,8.5-18.9,18.9-18.9h158
                        c10.4,0,18.9,8.4,18.9,18.9v29H158.1V53z M89.9,116.1h332.2v37.5H89.9V116.1z M394.7,460.8c0,9.4-7.6,17.1-17.1,17.1H134.4
                        c-9.4,0-17.1-7.6-17.1-17.1V187.7h277.3V460.8z"
                            />
                            <path
                              d="M170.7,447c9.4,0,17-7.6,17.1-17V235.6c0.2-9.4-7.2-17.2-16.7-17.5s-17.2,7.2-17.5,16.7c0,0.3,0,0.6,0,0.8V430
                        C153.6,439.4,161.3,447,170.7,447z"
                            />
                            <path
                              d="M256,447c9.4,0,17-7.6,17.1-17V235.6c0-9.4-7.6-17.1-17.1-17.1c-9.4,0-17.1,7.6-17.1,17.1V430C239,439.4,246.6,447,256,447z
                        "
                            />
                            <path
                              d="M341.3,447c9.4,0,17-7.6,17.1-17V235.6c0.2-9.4-7.2-17.2-16.7-17.5c-9.4-0.2-17.2,7.2-17.5,16.7c0,0.3,0,0.6,0,0.8V430
                        C324.3,439.4,331.9,447,341.3,447z"
                            />
                          </svg>
                          <!-- <img *ngIf="!selectedTicket.isForAllPassengers"
                width="24px"
                height="24px"
                style="cursor: pointer;"
                tooltip="Agregar pasajero"
                placement="bottom"
                (click)="toggleDeleteTooltip(currentTicketIndex)"
                src="../../../../assets/icons/itinerary/edit.svg" alt=""> -->
                          <!--
              <div *ngIf="showDeleteTooltip[currentTicketIndex]"
                class="delete-tooltip"
                style="position: absolute; top: 100%; right: 0; background: white; border: 1px solid #e0e0e0; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.15); z-index: 1000; min-width: 250px; padding: 12px; margin-top: 8px;">

                <div class="d-flex justify-content-between align-items-center mb-2">
                  <h6 style="font-family: 'Rubik', serif; font-weight: 500; margin: 0; font-size: 13px; color: #333;">
                    Agregar pasajero a {{ selectedTicket.option_name }}
                  </h6>
                  <button (click)="toggleDeleteTooltip(currentTicketIndex)"
                    class="btn btn-sm p-0"
                    style="background: none; border: none; font-size: 16px; color: #666; line-height: 1;">
                    ×
                  </button>
                </div>

                <div class="paxes-list">
                  <div *ngFor="let pax of availablePassengers; let paxIndex = index"
                    class="d-flex align-items-center justify-content-between p-2"
                    style="border-bottom: 1px solid #f0f0f0;">
                    <span style="font-family: 'Rubik', serif; font-weight: 400; font-size: 12px !important;">
                      {{ getPaxTypeLabel(pax.type) }}
                      {{ pax.age !== undefined && pax.age !== null && pax.age !== '' ? '(desde ' + pax.age + ' años)' : (pax.ageRange?.from !== undefined && pax.ageRange?.from !== null && pax.ageRange?.from !== '' ? '(desde ' + pax.ageRange?.from + '+ años)' : '') }}
                    </span>
                    <button (click)="selectedPax(currentTicketIndex, paxIndex)"
                      type="button"
                      class="btn btn-sm p-0"
                      style="background: none; border: none; color: #5bca90; font-size: 16px; font-weight: bold; cursor: pointer;">
                      <i class="bi bi-plus-circle"></i>
                    </button>
                  </div>
                  <div *ngIf="availablePassengers.length === 0" class="p-2 text-center text-muted" style="font-size: 12px;">
                    No hay más pasajeros disponibles
                  </div>
                </div>
              </div> -->

                          <!-- <img src="../../../../../assets/icons/itinerary/delet.svg"
                width="18px"
                height="20px"
                style="cursor: pointer; margin-left: 4px;"
                tooltip="Eliminar ticket"
                placement="bottom"
                (click)="removeTicketSelected(currentTicketIndex);"
                alt=""> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Footer con total y botón -->
            <div class="d-flex pt-4 justify-content-end" style="height: 75px; gap: 1em; margin-left: 2.8em; margin-right: 2em">
              <div *ngIf="validPaymentConditionAgencyAvailable('NR')" class="d-flex flex-column align-items-end justify-content-center">
                <p
                  class="mb-0"
                  style="font-family: &quot;Rubik&quot;, serif; font-size: 20px; font-weight: 500; line-height: 1; color: #666666"
                >
                  Total Tarifa Neta
                </p>
                <div class="d-flex">
                  <p
                    class="mb-0"
                    style="font-family: &quot;Rubik&quot;, serif; font-size: 22px; font-weight: 700; line-height: 1; color: black"
                  >
                    {{ currencyAgency?.code }}
                    {{
                      getSumPaxOptionTotalTickets()
                        | currencyConverterPure: tour.additionalInfo.currency : currencyAgency.code : currencies
                        | number: "1.2-2"
                    }}
                  </p>
                  <usb-tooltip-convert-amount
                    [clientsSettingAppBooking]="clientSetting"
                    [currencyProduct]="tour.additionalInfo.currency"
                    [valueProduct]="getSumPaxOptionTotalTickets()"
                  >
                  </usb-tooltip-convert-amount>
                </div>
              </div>

              <div
                *ngIf="!validPaymentConditionAgencyAvailable('NR')"
                class="d-flex justify-content-end py-2 mr-4"
                style="margin-bottom: 35px; margin-top: 25px"
              >
                <p class="mb-0 vehicle-middle-description" style="line-height: 1; color: red">
                  No es posible seleccionar un producto no reembolsable debido a las condiciones de pago de la agencia
                </p>
              </div>

              <button
                *ngIf="validPaymentConditionAgencyAvailable('NR')"
                type="button"
                class="pull-right btn btn-continue cursor-pointer"
                [ngStyle]="{ 'background-color': clientSetting?.clients_setting_global?.color_main_1 }"
                (click)="continue(null)"
              >
                Seleccionar
              </button>
            </div>
          </ng-container>

          <!-- <ng-container>
      <div class="d-flex flex-row flex-wrap w-100 mt-3" style="height: 50px;" *ngFor="let comment of comments">
          <p class="w-100" style="border-bottom: 1px solid rgb(223, 223, 223);">
            {{comment.comments}}
          </p>
      </div>
    </ng-container> -->
        </div>
      </ng-container>

      <!---------------------------- DIV DE MAPAS --------------------->

      <div *ngIf="tab === 'maps'" style="margin-left: 2.8em; margin-right: 2em">
        <app-map-view
          [coordinatesArr]="coordinatesArr"
          [clientSetting]="clientSetting"
          [currencies]="currencies"
          mapMode="general"
          [currencyAgency]="currencyAgency"
        ></app-map-view>
      </div>

      <!---------------------------- DIV DE FOTOS --------------------->
      <!-- [ngClass]="{ 'd-block': tab === 'photos', 'd-none': tab != 'photos' }" -->
      <div *ngIf="tab === 'photos'" style="margin-left: 2.8em; margin-right: 2em">
        <ng-container *ngIf="payload[0].categoriesId[0] == 6">
          <usb-photos [images]="tour?.additionalInfo?.images"> </usb-photos>
        </ng-container>
      </div>

      <!---------------------------- DIV DE INFO --------------------->
      <div *ngIf="tab === 'info'">
        <usb-information
          [categoryId]="6"
          [subCategoryId]="payload[0].categoriesId[0]"
          [product]="tour"
          [clientSetting]="clientSetting"
          [openInfoDescription]="openInfoDescription"
          [payload]="payload"
          (goPhotos)="goPhotosFx()"
        >
        </usb-information>
      </div>

      <!-- Comentarios -->
      <ng-container>
        <div [ngClass]="{ 'd-block': tab === 'comments', 'd-none': tab != 'comments' }" style="margin-left: 2.8em; margin-right: 2em">
          <usb-comments
            [clientSetting]="clientSetting"
            [payload]="payloadUpdate"
            [productId]="tour?.productId"
            [action]="action"
            (closeModal)="close()"
          >
          </usb-comments>
        </div>
      </ng-container>
    </div>
  </div>
</div>
